module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Raya Collections","short_name":"Raya","description":"Handpicked sarees & women's wear. DM or WhatsApp to order.","start_url":"/","background_color":"#f6e8e0","theme_color":"#b95c3f","display":"standalone","icon":"src/images/icon-mark-512.png","icon_options":{"purpose":"any maskable"},"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ca9f4c23169505e17151dd7270c2d782"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
